module.exports = __webpack_public_path__ + "img/SLN_thumb_320_2122.0d2f9a02.jpg";